import React from 'react'
import { connect } from 'react-redux'
import { editSets } from "../../actions/settings"
import Select from 'react-select'
import { fnum, sortOpts } from '../../utils/utils'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import SettingsItemForm from './SettingsItemForm'

class SetsSrvcItem extends SettingsItemForm {

  modelName = 'srvc'

  render() {
    const { srvgs, data } = this.props;
    const { data: nData, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    var srvgsOpt = [];
    for (var key in srvgs){
      if(srvgs.hasOwnProperty(key) && (srvgs[key].srvg_active === 1
        || srvgs[key].srvg_id === nData.srvc_srvg_id)) {
        srvgsOpt.push({value:srvgs[key].srvg_id,label:srvgs[key].srvg_desc});
      }
    }
    srvgsOpt.sort(sortOpts);

    if(this.state.editing){
      return(
        <tr>
          <td>
          {delConf}
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.srvc_desc}
                name="srvc_desc"
                onChange={this.updateInput}
                placeholder="Краткое название"
                autoFocus
              />
              <textarea type="text"
                className="form-control"
                value={nData.srvc_longdesc}
                name="srvc_longdesc"
                onChange={this.updateInput}
                placeholder="Длинное описание"
                title="Длинное описание"
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>
            <Select
              clearable={false}
              options={[{value:1,label:'Услуга'},{value:-1,label:'Оплата'}]}
              value={nData.srvc_type}
              onChange={e => this.updateSelect(e,'srvc_type')}
              placeholder="Тип"
            />
          </td>
          <td>
            <Select
              clearable={false}
              options={srvgsOpt}
              value={nData.srvc_srvg_id}
              onChange={e => this.updateSelect(e,'srvc_srvg_id')}
              placeholder="Группа услуг"
            />
            <label>
              Заказы{" "}
            <input type="checkbox" checked={nData.srvc_post} name="srvc_post"
              onChange={this.handleChBox} />
            </label>{" "}
            <label>
              Издержки{" "}
            <input type="checkbox" checked={nData.srvc_expense} name="srvc_expense"
              onChange={this.handleChBox} />
            </label>
          </td>
          <td>
            <input type="text"
              className="form-control"
              value={nData.srvc_price}
              name="srvc_price"
              onChange={this.updateInput}
              placeholder="Цена"
            />
          </td>
          <td>
            <input type="text"
              className="form-control"
              value={nData.srvc_cost}
              name="srvc_cost"
              onChange={this.updateInput}
              placeholder="Себес."
            />
          </td>
        </tr>
      );
    }
    else{
      return (
        <tr onClick={this.startEditing}>
          <td>{data.srvc_desc}</td>
          <td>{data.srvc_type===1?'Услуга':'Оплата'}</td>
          <td>{srvgs[data.srvc_srvg_id].srvg_desc}</td>
          <td className="text-right">{fnum(data.srvc_price)}</td>
          <td className="text-right">{fnum(data.srvc_cost)}</td>
        </tr>
      );
    }

  }
}

export default connect(null, { editSets })(SetsSrvcItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsSrvcItem.js